import { TokenMeta } from './types';

export type { WithMeta, TokenMeta, WithRange } from './types';
export { TokenStream } from './token-stream';
export { lex } from './lex';
export type { Token } from './tokens';
export * as T from './tokens';

export const combineRanges = (
  ...ranges: TokenMeta['range'][]
): TokenMeta['range'] =>
  ranges.reduce((acc, curr): TokenMeta['range'] => {
    if (acc === null) {
      return curr;
    }

    if (curr === null) {
      return acc;
    }

    const range: TokenMeta['range'] = [
      Math.min(acc[0], curr[0]),
      Math.max(acc[1], curr[1]),
    ];

    return range;
  });

import { lex } from './lex';
import _ from 'lodash';

export const identifiersOf = (eraql: string): string[] => {
  const idents = [...lex(eraql)]
    .map(([token, _meta]) => (token.t === 'ident' ? token.name : null))
    .filter((x) => x !== null);

  return _.uniq(idents).sort();
};
